import React from "react";
import { css } from "@emotion/react";
import { Label, Font } from "@moneyforward/mfx_biz_react_components";
import { useIsSpMode } from "@/hooks";
import { dateValidation } from "@/components/validations";
import { FormErrorMessage, FormTextField } from "@/components/molecules";

type Props = {
  name: string;
  labelRequired: boolean;
};

const FoundationDateFormFieldComponent = (
  props: Props,
  ref: React.ForwardedRef<HTMLInputElement>
) => {
  const isSpMode = useIsSpMode();
  return (
    <div css={!isSpMode ? container : {}}>
      <div css={labelWrapper}>
        <Font variant="m" component="p">
          設立年月日 {props.labelRequired && <Label variant="required" />}
        </Font>
      </div>
      <div css={inputWrapper}>
        <div css={textFieldWrapper}>
          <FormTextField
            name={props.name}
            placeholder={"例）2012/01/01"}
            registerOptions={{
              validate: dateValidation,
            }}
            ref={ref}
          />
        </div>
        <div css={errorWrapper}>
          <FormErrorMessage name={props.name} />
        </div>
      </div>
    </div>
  );
};

export const FoundationDateFormField = React.forwardRef(
  FoundationDateFormFieldComponent
);

const container = css({
  display: "flex",
});

const labelWrapper = css({
  width: "160px",
  marginRight: "16px",
  paddingTop: "10px",
  paddingBottom: "4px",
});

const inputWrapper = css({
  width: "100%",
  flex: 1,
});

const textFieldWrapper = css({
  maxWidth: "196px",
});

const errorWrapper = css({
  flex: 1,
});
